import { RatingTablePutSchema } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import { Field, Formik } from "formik";
import { useRatingTable } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import { Card, Form, Header } from "semantic-ui-react";
import AppliedAtSelect from "./AppliedAtSelect";
import RatingTableTypeSelect from "./RatingTableTypeSelect";

const RatingTableForm = () => {
  const { ratingTable, update, validateRatingTableName } = useRatingTable();
  return (
    <Fragment>
      <Header as="h3">Edit Details</Header>
      <Card fluid>
        <Card.Content>
          <Formik
            validateOnChange={false}
            initialValues={ratingTable}
            validationSchema={RatingTablePutSchema}
            onSubmit={(values, actions) => {
              update(values);
            }}
          >
            {({ handleSubmit, errors, validateField }) => (
              <Form onSubmit={handleSubmit}>
                <Field
                  name="name"
                  label="Name"
                  validate={validateRatingTableName}
                  component={CallableInput}
                />

                <Field
                  name="description"
                  label="Description"
                  component={CallableInput}
                />

                <AppliedAtSelect name="appliedAt" label="Applied At" />

                <RatingTableTypeSelect name="type" label="Type" />

                <FormSubmit name="Update" errors={errors} />
              </Form>
            )}
          </Formik>
        </Card.Content>
      </Card>
    </Fragment>
  );
};

export default RatingTableForm;
